module.exports = __webpack_public_path__ + "img/zodiakLogo.23ce0fef.jpg";